import React, { Component } from "react";
import {
    Container,
    Form,
    Button
} from "semantic-ui-react";
import set from "lodash/set";

import request from "../../utils/request";
import ResponseMessage from "../../components/common/ResponseMessage";

const locationProfile = () => {
    return {
        id: 0,
        name: ""
    };
};

const resetState = (id) => {
    return {
        isLoading: true,
        xhrStatus: "",
        xhrMessage: "",
        locationId: id ? id : 0,
        profile: locationProfile()
    };
};

class LocationForm extends Component {
    constructor(props) {
        super(props);
        this._isMounted = false;
        this.state = resetState(this.props.match.params.id);

        this.handleChange = this.handleChange.bind(this);
        this.fetchData = this.fetchData.bind(this);
    }
    componentDidMount = () => {
        this._isMounted = true;
        if (this.props.match.params.id === ":id") {
            this.props.history.replace('/locations');
            return;
        }
        this._isMounted && this.fetchData();
    };
    componentWillUnmount = () => {
        this._isMounted = false;
        this.setState(resetState(this));
    };
    fetchData = () => {
        let self = this;
        let promises = [];
        if (this.state.locationId > 0) {
            promises.push(
                request.get(this, `api:/location/${this.state.locationId}`, { ts: Date.now() })
            );
        }
        Promise.all(promises).then(function (values) {
            if (values[0]) {
                self.setState({ profile: values[0] });
            }
            self.setState({ isLoading: false });
        });
    };
    handleChange = (e, { name, value }) => {
        let data = this.state.profile;
        set(data, name, value);
        this.setState({ profile: data });
    };
    handleSubmit = () => {
        let req;
        this.setState({
            isLoading: true,
            xhrStatus: "",
            xhrMessage: ""
        });
        const { profile } = this.state;
        let formData = new FormData();
        formData.append("name", profile.name);
        if (profile.id > 0) {
            req = request.post(this, `api:/location/${profile.id}?_method=PUT`, formData);
        } else {
            req = request.post(this, "api:/location", formData);
        }
        req.then(resp => {
            this.setState({
                xhrStatus: resp.success ? "success" : "error",
                xhrMessage: resp.message,
                isLoading: false
            });
            if (resp.success) {
                if (this.state.locationId === 0) this.setState({ profile: locationProfile() });
                setTimeout(() => this.setState({ xhrStatus: '', xhrMessage: '' }), 4000);
            }
        })
    };
    handleDismissPortal = () => {
        if (this.state.xhrStatus === '') return null;
        this.setState({ xhrStatus: '', xhrMessage: '' });
    }
    render() {
        const {
            isLoading,
            xhrStatus,
            xhrMessage,
            profile
        } = this.state;

        return (
            <Container text>
                <Form 
                    loading={isLoading}
                    success={xhrStatus === "success"}
                    error={xhrStatus === "error"}
                    onBlur={this.handleDismissPortal}
                >
                    <Form.Input
                        fluid
                        name="name"
                        label="Name of Location"
                        placeholder="Name of Location"
                        value={profile.name}
                        onChange={this.handleChange}
                        required
                    />
                    <Button
                        icon="save"
                        content="Save"
                        primary
                        floated="right"
                        onClick={this.handleSubmit}
                    />
                    <ResponseMessage status={xhrStatus} message={xhrMessage} />
                </Form>
            </Container>
        );
    }
}

export default LocationForm;
